import React, { useState } from 'react';
import Input from '../../Components/Playgrond/Input';
import AuthenticatedTemplate from '../../Components/Templates/Authenticated';
import fetch from '../../support/fetch';
import {Button} from 'tabler-react';
import SelectedPlan from '../../Components/SelectedPlan';

const FreeSubscription = () => {
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [code, setCode] = useState('');

    const onCloseModalHandler = open => {
        setShowModal(open);
        // console.log('fechar modal invocado...', open);
    };

    const onSubmitHandler = (e) =>{
        e.preventDefault();

        fetch.obj({
            query: `query FetchAllAvailablePlans($subscriberType: String!, $couponCode: String) {
                availablePlans (subscriberType: $subscriberType, couponCode: $couponCode) {
                    id,
                    name,
                    description,
                    currency,
                    amount,
                    amountFrom,
                    paymentMethod,
                    paymentMethodCode,
                    unit,
                    length,
                    code,
                }
            }`,
            variables: {
                subscriberType: "adult",
            }
        })
        .then(res => {
            if (! res.data.hasOwnProperty('availablePlans')) {
                return;
            }
            
            for(let i = 0; i < res.data.availablePlans.length; i++) {
                let plan = res.data.availablePlans[i];
                if(plan.code === "OOPPAH_PROFILE_FREE"){
                    setSelectedPlan(plan);
                }
            }
            setShowModal(true);
        });
    }

    return (
        <AuthenticatedTemplate withSidebar={false}>
            <div className="row">
                <div className="col-md-2">

                </div>
                <div className="col-md-8">
                    <p className="display-4 display-text mt-6">Deseja Confirmar sua mudança para plano Gratuito ?</p>
                    <form onSubmit={onSubmitHandler}>
                        <div className="row gutters-xs">
                            <div className="col-auto">
                                <Button
                                    className={
                                        'btn ' + (
                                            false
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        )
                                    }
                                    loading={false}>Confirmar mudança para plano gratuito</Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <SelectedPlan
                open={showModal}
                onClose={onCloseModalHandler}
                plan={selectedPlan}
                couponCode={code}
            />

        </AuthenticatedTemplate>
        
    );
}

export default FreeSubscription;